var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 56,
    viewBox: "0 0 51 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2205 0H43.1086H7.05808H6.94615C3.1099 0 0 2.67832 0 5.9822V6.51277V49.4872V50.0178C0 53.3217 3.1099 56 6.94615 56H7.05808H43.1086H43.2205C47.0568 56 50.1667 53.3217 50.1667 50.0178V49.4872V6.51277V5.9822C50.1667 2.67832 47.0568 0 43.2205 0ZM7.02213 4.32047H6.94615C5.88053 4.32047 5.01667 5.06445 5.01667 5.9822V50.0178C5.01667 50.9355 5.88053 51.6795 6.94615 51.6795H7.05555L19.8243 28.1444L7.02213 4.32047ZM17.9303 4.32047L25.34 17.9779L32.7496 4.32047H17.9303ZM43.637 4.35929L30.8557 28.1444L43.6064 51.6463C44.4871 51.4923 45.15 50.8217 45.15 50.0178V5.9822C45.15 5.18761 44.5024 4.52328 43.637 4.35929ZM32.4712 51.6795L25.34 38.4088L18.2088 51.6795H32.4712Z",
    fill: "#C82828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeSmall);
export default __webpack_public_path__ + "static/media/strike-small.d00474455f19eb4245ae48193808ec66.svg";
export { ForwardRef as ReactComponent };